// 채팅 세션 공유 1차 상태 — 여러 훅이 함께 쓰는 핵심(대화목록·현재 대화·메시지·프로젝트 선택·코워크).
// 순환 의존을 끊기 위해 이 핵심 상태만 한곳에 두고, 각 도메인 훅(useConversation/useChatMessage/
// useProjects/useWorkspace)이 이 객체를 받아 동작한다. ChatPage는 이 객체를 만들어 훅들에 배선한다.
import { useState, useEffect, useRef } from 'react';
import { historyAPI } from '../../../api/client';

export default function useChatCore() {
  const [conversations, setConversations] = useState([]);
  const [currentConvId, setCurrentConvId] = useState(null);
  const [messages, setMessages]           = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [currentProjectAccessRole, setCurrentProjectAccessRole] = useState(null);
  const [cowork, setCowork]               = useState(true);        // 코워크 기본 ON(프로젝트 대화 시 작업공간 파일 도구 기본 활성)
  const currentConvIdRef = useRef(null);  // currentConvId 라이브 미러(done 콜백 stale closure 회피)

  // currentConvId 라이브 미러 — 백그라운드 스트림 done 시 '지금 이 대화를 보고 있나' 판단용
  useEffect(() => { currentConvIdRef.current = currentConvId; }, [currentConvId]);

  // 최초 대화목록 로드
  useEffect(() => { historyAPI.listConversations().then((r) => setConversations(r.data)); }, []);

  return {
    conversations, setConversations, currentConvId, setCurrentConvId, messages, setMessages,
    selectedProjectId, setSelectedProjectId, currentProjectAccessRole, setCurrentProjectAccessRole,
    cowork, setCowork, currentConvIdRef,
  };
}
